
import { ToastContainer, toast } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';
const ThemeBtn = ({setTheme}) => {

    let themes = ["light", "dark", "cupcake", "bumblebee", "emerald", "corporate", "synthwave", "retro", "cyberpunk", "valentine", "halloween", "garden", "forest", "aqua", "lofi", "pastel", "fantasy", "wireframe", "black", "luxury", "dracula", "cmyk", "autumn", "business", "acid", "lemonade", "night", "coffee", "winter"]

    let chngThm = (e)=> {
        e.preventDefault();
        let theme = e.target.innerText;
        setTheme(theme.toLowerCase());
        toast(`Theme changed to ${theme}`, {
            position: "top-center",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
            });
    }

    return (
        <div className="dropdown dropdown-top dropdown-end dropdown-hover fixed bottom-5 lg:right-96 right-10 bg-transparent">
            <ToastContainer />
            <label tabIndex={0} className="btn text-xl p-3 rounded-full"><i className="fa-solid fa-circle-half-stroke"></i></label>
            <ul tabIndex={0} className="dropdown-content menu shadow-xl bg-transparent w-52  max-h-[300px] flex-nowrap overflow-hidden overflow-y-scroll scroll-auto">
                {
                    themes.map((t,idx) => <li
                    className='py-1 border border-1 border-success rounded-xl cursor-pointer bg-base-100'
                    onClick={chngThm}
                    key = {idx}
                    >{t.toUpperCase()}</li>)
                }
            </ul>
        </div>
    );
};

export default ThemeBtn;